import axios from 'axios'

const prefix = 'https://kc.xinli001.com/'

// 获取首页信息
export const getIndexData = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/index`, {
    params
  })
}
// 获取精选列表
export const getFeaturedData = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getFeaturedList`, {
    params
  })
}
// 获取练习是否加入
export const checkIsJoin = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/checkIsJoin`, {
    params
  })
}
//vip页面接口
export const meditationVip = (params = {}) => {
  return axios.get(`${prefix}lingxikc/user/api/vip`, {
    params
  })
}
// 冥想支付接口
export const meditationPay = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/pay`, {
    params
  })
}

// 冥想分销卡
export const vipDisCard = (params = {}) => {
  return axios.get(`${prefix}lingxikc/user/api/vipDisCard`, {
    params
  })
}
//vip信息是否有效
export const meditationVipinfo = (params = {}) => {
  return axios.get(`${prefix}lingxikc/user/api/vipUserInfo`, {
    params
  })
}
// 领取分销卡页面接口(拼手气)
export const vipGetPackage = (params = {}) => {
  return axios.get(`${prefix}lingxikc/user/api/vipGetPackage`, {
    params
  })
}
// 看看谁领了页面接口
export const vipPackage = (params = {}) => {
  return axios.get(`${prefix}lingxikc/user/api/vipPackage`, {
    params
  })
}
// 领取礼物
export const shareGift = (params = {}) => {
  return axios.get(`${prefix}lingxikc/api/vipGift/shareGiftVip`, {
    params
  })
}
// 领取成功
export const receiveGift = (params = {}) => {
  return axios.get(`${prefix}lingxikc/api/vipGift/receiveGiftVip`, {
    params
  })
}
// 赠送好友
export const giftFriend = (params = {}) => {
  return axios.get(`${prefix}lingxikc/api/vipGift/giftFriend`, {
    params
  })
}
// 我的赠送
export const myGiftList = (params = {}) => {
  return axios.get(`${prefix}lingxikc/api/vipGift/myGiftList`, {
    params
  })
}
//我的收益
export const myProfit = (params = {}) => {
  return axios.get(`${prefix}lingxikc/common/api/getMyReward`, {
    params
  })
}
//收益列表
export const profitList = (params = {}) => {
  return axios.get(`${prefix}lingxikc/common/api/getMyRewardList`, {
    params
  })
}
// 获取搜索热词
export const searchWords = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/searchWords`, {
    params
  })
}
// 搜索练习列表
export const searchPractices = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/searchMeditating`, {
    params
  })
}
//分类标签
export const sortTags = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/tagList`, {
    params
  })
}
//分类列表
export const practiceTagList = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/meditatingTagList`, {
    params
  })
}
//我的
export const myHomeInfo = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/myHomeInfo`, {
    params
  })
}
//支付弹框
export const paySuccessPopup = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/paySuccessPopup`, {
    params
  })
}
//支付失败弹窗
export const payErrorPopup = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/payFailPopup`, {
    params
  })
}
//重定向
export const redirect = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/giving`, {
    params
  })
}
//退出
export const signOut = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/signOut`, {
    params
  })
}

/**
 * 获取我的消息
 * @param channelId
 * @returns {AxiosPromise<any>}
 */
export const fetchMyPrompt = ({ channelId = 1741 }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/myPrompt`, {
    params: {
      channelId
    }
  })
}

/**
 * 清除消息提示
 * @param channelId
 * @param objectName externalLike=外部红点，actualLike=实际未读赞，commentNum=评论数
 * @returns {AxiosPromise<any>}
 */
export const clearMyPrompt = ({ channelId, objectName }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/clearMyPrompt`, {
    params: {
      channelId,
      objectName
    }
  })
}

/**
 * 获取回复我的列表
 * @param channelId
 * @param page
 * @param size
 * @returns {AxiosPromise<any>}
 */
export const fetchReplyMeList = ({ channelId = 1741, page = 1, size = 30 }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/replyMeList`, {
    params: {
      channelId,
      page,
      size
    }
  })
}

/**
 * 获取收到的赞列表
 * @param channelId
 * @param page
 * @param size
 * @returns {AxiosPromise<any>}
 */
export const fetchReceivedLikeList = ({
  channelId = 1741,
  page = 1,
  size = 30
}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/receivedLikeList`, {
    params: {
      channelId,
      page,
      size
    }
  })
}

/**
 * 获取感悟详情
 * @param channelId
 * @param rateId
 * @returns {AxiosPromise<any>}
 */
export const fetchMediRateDetail = ({ channelId, rateId }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getMediRateDetail`, {
    params: { channelId, rateId }
  })
}

/**
 * 获取感悟下评论列表
 * @param channelId
 * @param rateId
 * @param page
 * @param size
 * @returns {AxiosPromise<any>}
 */
export const fetchMediRateCommentList = ({
  channelId,
  rateId,
  page = 1,
  size = 10
}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getMediRateCommentList`, {
    params: { channelId, rateId, page, size }
  })
}

/**
 * 获取评论用户信息列表
 * @param channelId
 * @param userKeys
 * @returns {AxiosPromise<any>}
 */
export const fetchMediRateUserList = ({ channelId, userKeys = [] }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getMediRateUserList`, {
    params: { channelId, userKeys }
  })
}

/**
 * 冥想点赞接口
 * @param channelId
 * @param objectName 评论类型，冥想感悟=college_meditating，冥想感悟评论=college_meditating_comment
 * @param rateId
 * @returns {AxiosPromise<any>}
 */
export const likeComment = ({
  channelId,
  objectName = 'college_meditating',
  rateId
}) => {
  return axios.post(`${prefix}lingxikc/meditating/api/likeComment`, {
    channelId,
    objectName,
    rateId
  })
}

/**
 * 删除感悟/评论
 * @param channelId
 * @param objectId 评论对象ID
 * @param isRate true删除感悟，false删除评论
 * @returns {AxiosPromise<any>}
 */
export const delRateOrComment = ({ channelId, objectId, isRate = true }) => {
  return axios.post(`${prefix}lingxikc/meditating/api/delRateOrComment`, {
    channelId,
    objectId,
    isRate
  })
}

/**
 * 感悟评论-发布评论
 * @param channelId
 * @param objectId
 * @param isRate
 * @param content
 * @returns {AxiosPromise<any>}
 */
export const publishRateComment = ({
  channelId,
  objectId,
  isRate = true,
  content
}) => {
  return axios.post(`${prefix}lingxikc/meditating/api/publishRateComment`, {
    channelId,
    objectId,
    isRate,
    content
  })
}

/**
 * 获取二级评论列表
 * @param channelId
 * @param rateId
 * @param page
 * @param size
 * @returns {AxiosPromise<any>}
 */
export const getMediSecondaryCommentList = ({
  channelId,
  commentId,
  page = 1,
  size = 20
}) => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/getMediSecondaryCommentList`,
    {
      params: {
        channelId,
        commentId,
        page,
        size
      }
    }
  )
}

/**
 * 获取感悟评论详情
 * @param channelId
 * @param commentId
 * @returns {AxiosPromise<any>}
 */
export const getMediRateCommentDetail = ({ channelId, commentId }) => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/getMediRateCommentDetail`,
    {
      params: {
        channelId,
        commentId
      }
    }
  )
}

// 赠送30天vip
export const giveVip = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/giveVip`, {
    params
  })
}

// 后背计划 传值queryVo.meditatingIds=[id1,id2]
export const getMeditatingListByIds = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getMeditatingListByIds`, {
    params
  })
}

/**
 * 获取声音分类列表
 * @param channelId
 * @returns {AxiosPromise<any>}
 */
export const tagVoiceList = ({ channelId }) => {
  return axios.get(`${prefix}lingxikc/mediVoice/api/tagVoiceList`, {
    params: {
      channelId
    }
  })
}

/**
 * 获取vip亲友卡邀请的用户  */
export const getReceiveUser = ({ channelId }) => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/vipFriendsFission/getReceiveUser`,
    {
      params: {
        channelId
      }
    }
  )
}

export const receiveCard = ({ channelId, fromUserKey }) => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/vipFriendsFission/receive`,
    {
      params: {
        channelId,
        fromUserKey
      }
    }
  )
}

export const getRelativeInvite = ({ channelId, fromUserKey }) => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/vipFriendsFission/getFissionInvite`,
    {
      params: {
        channelId,
        fromUserKey
      }
    }
  )
}

export const getUserMediRate = params => {
  return axios.get(`${prefix}lingxikc/meditating/api/getUserMediRate`, {
    params
  })
}

export const followUser = ({ userKey }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/follower`, {
    params: {
      'queryVo.userKey': userKey
    }
  })
}

export const getUserHomeInfo = ({ userKey }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/home`, {
    params: {
      'queryVo.userKey': userKey
    }
  })
}

export const fetchFansMyList = ({ size = 30, lastUserKey = '' }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getUserFollower`, {
    params: {
      'queryVo.lastUserKey': lastUserKey,
      'queryVo.size': size,
      'queryVo.userKey': ''
    }
  })
}
export const getRecommendRate = ({ page = 1, size = 50 }) => {
  return axios.get(`${prefix}lingxikc/meditating/api/getRecommendMediRate`, {
    params: {
      'queryVo.page': page,
      'queryVo.size': size
    }
  })
}

export const getUserDayData = dataArr => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/getMyMediDataInfoWithDate`,
    {
      params: {
        dates: dataArr
      }
    }
  )
}

export const getUserDataWithMonth = dataArr => {
  return axios.get(
    `${prefix}lingxikc/meditating/api/getMyMediDataInfoWithMonth`,
    {
      params: {
        months: dataArr
      }
    }
  )
}

//获取试听或赠送音频数据
export const getPlanPlayInfo = (params = {}) => {
  return axios.get(`${prefix}lingxikc/meditating/api/plan/planPlay`, {
    params
  })
}
